export const MigrationRoutes = { path: 'migration/*', lazy: () => import('../pages/migration') };
